export const ProductImages = (function() {
	'use strict';

	let $secondaryImage;

	function init() {
		$secondaryImage = $('.product .secondary-image');
		$secondaryImage.click(swapImages);
	}

	function swapImages(e) {
		let $img2Container = $(this),
				$img2 = $img2Container.html(),
				$img1Container = $img2Container.closest('.images').find('.main-image'),
				$img1 = $img1Container.html();

		$img2Container.html($img1);
		$img1Container.html($img2);
	}

	return {
		init: init
	};
})();
